
export default {
  setPaymentDiscountInfo (storeData, paymentMethod, support, discount) {
    const payDiscount = storeData.payDiscount ? Object.assign({}, storeData.payDiscount) : {}

    if (support) {
      payDiscount[paymentMethod] = discount
    } else {
      delete payDiscount[paymentMethod]
    }
    return payDiscount
  },
  setMenuReceiptSetting (storeData, variation, useReceipt) {
    const menuReceiptSetting = storeData.menuReceiptSetting ? Object.assign({}, storeData.menuReceiptSetting) : {}

    menuReceiptSetting[variation] = {
      menuVariation: variation,
      useReceipt
    }
    return menuReceiptSetting
  }
}
